/**
 * @fileoverview Address field labels with required field indicators
 * @description Contains JSX elements for address form field labels, including visual indicators
 * for required fields using asterisk (*) symbols with 'required' CSS class styling.
 */

/**
 * Frozen object containing address field labels with required field indicators.
 * Each property represents a label for a specific address field component.
 * Required fields are marked with a red asterisk using the 'required' CSS class.
 * 
 * @type {Readonly<{
 *   line1: JSX.Element,
 *   line2: JSX.Element,
 *   city: JSX.Element,
 *   state: JSX.Element,
 *   zipCode: JSX.Element
 * }>}
 * @constant
 * @readonly
 */
export const AddressLabelsWithRequiredIndicator = Object.freeze({
    line1: <>Street Address<span className='required'>*</span></>,
    line2: <>Street Address 2</>,
    city: <>City<span className='required'>*</span></>,
    state: <>State<span className='required'>*</span></>,
    zipCode: <>ZIP Code<span className='required'>*</span></>
});